exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-for-receipt{width:90%;margin:-10px auto 0px auto}.email-for-receipt .MuiFormControl-root{width:100%}.email-for-receipt .MuiInputLabel-formControl{position:relative}.email-for-receipt .MuiInputLabel-shrink{margin-bottom:2px;margin-top:20px;font-family:\"Helvetica\",Arial;font-size:16px;color:rgba(0,0,0,.6)}.email-for-receipt .MuiOutlinedInput-input{padding:12px 16px 12px;font-family:\"Visby CF\",\"Arial\";font-size:1rem;letter-spacing:.15px;color:rgba(0,0,0,.87)}", ""]);

// exports
